import React, { useEffect, useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';

const PredefinedMessageTour = ({ forceStart, onTourEnd, hasMessages }) => {
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (forceStart) {
      setRun(false);
    }

    const seenTour = localStorage.getItem('tour_seen_predefined');

    if (!forceStart && seenTour) return;

    const timer = setTimeout(() => {
      let allSteps = [
        {
          target: '.tour-predefined-table',
          content: 'This table displays all your active Predefined Messages. These act as shortcuts to help you send common responses, links, or files quickly during a patient chat.',
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '.tour-predefined-add-btn',
          content: 'Click here to create a new shortcut. You can assign a keyword, a description, URLs, and even attach standard documents.',
          placement: 'left',
          disableBeacon: true,
        }
      ];

      if (document.querySelector('.tour-predefined-edit-btn')) {
        allSteps.push({
          target: '.tour-predefined-edit-btn',
          content: 'Need to make a change? Click the Edit icon to update the keyword, text, or attachments of an existing message.',
          placement: 'bottom',
          disableBeacon: true,
        });
      }
      
      if (document.querySelector('.tour-predefined-delete-btn')) {
        allSteps.push({
          target: '.tour-predefined-delete-btn',
          content: 'Click the Trash icon to permanently remove a predefined message you no longer need.',
          placement: 'bottom',
          disableBeacon: true,
        });
      }

      setSteps(allSteps);
      
      if (allSteps.length > 0) {
        setRun(true);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [forceStart, hasMessages]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      
      if (onTourEnd) {
        onTourEnd();
      }
      
      localStorage.setItem('tour_seen_predefined', 'true');
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      hideCloseButton={true}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: '#000000', 
          textColor: '#000000',
          zIndex: 9999,
        },
        tooltip: {
          borderRadius: '8px',
          padding: '20px',
        },
        buttonNext: {
          backgroundColor: '#3c8138',
          borderRadius: '4px',
        },
        buttonBack: {
          color: '#3c8138',
        }
      }}
    />
  );
};

export default PredefinedMessageTour;